module.exports = __webpack_public_path__ + "static/img/ur.c4a19993.png";